import { TEST_IDS } from "../testing/testIds";
import type { MissedBellBannerState } from "../hooks/useMissedBellBanner";
import styles from "./MissedBellBanner.module.css";

type Props = Pick<MissedBellBannerState, "visible" | "dismiss">;

export function MissedBellBanner({ visible, dismiss }: Props) {
  if (!visible) return null;

  return (
    <div
      className={styles.banner}
      data-testid={TEST_IDS.MISSED_BELL_BANNER}
      role="status"
      aria-live="polite"
    >
      <span>A bell rang while your screen was locked</span>
      <button
        className={styles.dismiss}
        onClick={dismiss}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
